/* tslint:disable max-line-length */
const metaDataList: any = {
  '/': {
    title: 'クイズを作成 | 結婚式の2次会を盛り上げるリアルタイム参加型クイズ',
    description:
      '新郎新婦を支える結婚式2次会の幹事必見！ennoshitaならゲストを楽しませるためのクイズゲームが簡単に作れます。ゲストは自分のスマホからマルバツクイズや4択クイズに参加でき、ディスプレイやスクリーンが見づらい会場でも便利です。'
  },
  '/presentation': {
    title: 'ennoshita'
  },
  '/controller': {
    title: 'ennoshita'
  },
  '/signup': {
    title: '会員登録 | 結婚式の2次会を盛り上げるリアルタイム参加型クイズ',
    description:
      '新郎新婦を支える結婚式2次会の幹事必見！ennoshitaならゲストを楽しませるためのクイズゲームが簡単に作れます。ゲストは自分のスマホからマルバツクイズや4択クイズに参加でき、ディスプレイやスクリーンが見づらい会場でも便利です。'
  },
  '/login': {
    title: 'ログイン | 結婚式の2次会を盛り上げるリアルタイム参加型クイズ',
    description:
      '新郎新婦を支える結婚式2次会の幹事必見！ennoshitaならゲストを楽しませるためのクイズゲームが簡単に作れます。ゲストは自分のスマホからマルバツクイズや4択クイズに参加でき、ディスプレイやスクリーンが見づらい会場でも便利です。'
  },
  '/password_reset_page': {
    title: 'パスワード変更ページ | 結婚式の2次会を盛り上げるリアルタイム参加型クイズ',
    description:
      '新郎新婦を支える結婚式2次会の幹事必見！ennoshitaならゲストを楽しませるためのクイズゲームが簡単に作れます。ゲストは自分のスマホからマルバツクイズや4択クイズに参加でき、ディスプレイやスクリーンが見づらい会場でも便利です。'
  },
  '/payment': {
    title: '購入 | 結婚式の2次会を盛り上げるリアルタイム参加型クイズ',
    description:
      '新郎新婦を支える結婚式2次会の幹事必見！ennoshitaならゲストを楽しませるためのクイズゲームが簡単に作れます。ゲストは自分のスマホからマルバツクイズや4択クイズに参加でき、ディスプレイやスクリーンが見づらい会場でも便利です。'
  }
}

export default metaDataList
